import React from 'react'
import LockedIcon from 'transfix-icons/build/LockedIcon'
import Card from 'transfix-ui/components/Card'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { TEST_IDS } from '../../constants'

const PendingAccessCard = () => {
  return (
    <Card dataTest={TEST_IDS.pendingAccessCard}>
      <Box display='flex' flexDirection='column' alignItems='center'>
        <Box mb={1}>
          <LockedIcon size='xlarge' color='skyBlue6' />
        </Box>
        <Box mb={1}>
          <Typography variant='h3'>You&apos;ve requested access</Typography>
        </Box>
        <Typography variant='body2' align='center'>
          You requested approval to manage this carrier. An email was sent to the carrier&apos;s
          Admin to approve you. Once you are approved, you&apos;ll be able to customize this
          carrier&apos;s preferences.
        </Typography>
      </Box>
    </Card>
  )
}

export default PendingAccessCard
